// INVIO_DOC_v1 — scelta dei documenti azienda/lavoratori e link a scadenza
// INVIO_DOC_v3 — cestino sugli invii disattivati o scaduti
import React, { useState, useEffect } from "react";

const C = {
  bg: "#0f1117", surface: "#1a1d27", surface2: "#21253a", border: "#2a2e45", accent: "#f5a623",
  text: "#e8eaf2", muted: "#7b82a0", dim: "#4a5068", ok: "#3ecf8e", warn: "#f5a623", err: "#f06060",
};
const ETI_AZ = { obbligatori_legge: "Obbligatori per legge", certificazioni: "Certificazioni", polizze: "Polizze", altro: "Altro" };
const ETI_LAV = { formazione: "Formazione", idoneita: "Idoneità sanitaria", identita: "Documento d'identità", altro: "Altro" };
const SENSIBILI = ["idoneita", "identita"];
const CHIAVE_ULTIMA = "invio_doc_ultima_scelta";

function tok() { try { return localStorage.getItem("bertoc_jwt") || ""; } catch (e) { return ""; } }
async function api(url, opts) {
  const o = opts || {};
  const h = { Authorization: "Bearer " + tok() };
  if (o.body) h["Content-Type"] = "application/json";
  const r = await fetch(url, { method: o.method || "GET", headers: h, body: o.body ? JSON.stringify(o.body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || ("Errore " + r.status));
  return j;
}
function chiave(d) { return d.cat + "|" + (d.lavId || "") + "|" + d.tipo + "|" + d.filename; }
function nomeFile(fn) { return String(fn || "").replace(/\.pdf$/i, "").replace(/_+/g, " ").trim(); }
function dataIt(s) {
  if (!s) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(8, 10) + "/" + s.slice(5, 7) + "/" + s.slice(0, 4);
  return s;
}
function dataOra(iso) {
  try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch (e) { return ""; }
}

function Badge({ f }) {
  if (f.stato === "scaduto") return <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", background: C.err, borderRadius: 4, padding: "1px 6px" }}>SCADUTO {dataIt(f.scadenza)}</span>;
  if (f.stato === "in_scadenza") return <span style={{ fontSize: 11, color: C.warn }}>scade il {dataIt(f.scadenza)}</span>;
  if (f.scadenza) return <span style={{ fontSize: 11, color: C.muted }}>valido al {dataIt(f.scadenza)}</span>;
  return <span style={{ fontSize: 11, color: C.dim }}>senza scadenza</span>;
}

function Riga({ d, f, scelto, onToggle, sensibile }) {
  return (
    <label style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "9px 4px", borderBottom: "1px solid " + C.border + "66", cursor: "pointer" }}>
      <input type="checkbox" checked={scelto} onChange={() => onToggle(d)} style={{ width: 20, height: 20, marginTop: 1, accentColor: C.accent, flexShrink: 0 }} />
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 14, color: f.stato === "scaduto" ? C.err : C.text, wordBreak: "break-word" }}>
          {sensibile ? "🔒 " : ""}{nomeFile(f.filename)}
        </span>
        <Badge f={f} />
        {sensibile && <span style={{ fontSize: 11, color: C.muted }}>{" · dato personale, sceglilo solo se richiesto"}</span>}
      </span>
    </label>
  );
}

function Finestra({ onClose }) {
  const [carico, setCarico] = useState(true);
  const [errore, setErrore] = useState("");
  const [az, setAz] = useState({});
  const [lavs, setLavs] = useState([]);
  const [aperti, setAperti] = useState({});
  const [scelti, setScelti] = useState({});
  const [per, setPer] = useState("");
  const [nota, setNota] = useState("");
  const [giorni, setGiorni] = useState(3);
  const [creando, setCreando] = useState(false);
  const [creato, setCreato] = useState(null);
  const [copiato, setCopiato] = useState(false);
  const [tab, setTab] = useState("nuovo");
  const [storico, setStorico] = useState(null);

  useEffect(() => {
    const prima = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    carica();
    return () => { document.body.style.overflow = prima; };
  }, []);

  async function carica() {
    setCarico(true); setErrore("");
    try {
      const ja = await api("/api/azienda/files");
      setAz(ja.files || {});
      const jl = await api("/api/lavoratori");
      const attivi = (jl.lavoratori || []).filter(l => l && l.attivo !== false)
        .sort((a, b) => String(a.nome_completo || a.nome || "").localeCompare(String(b.nome_completo || b.nome || "")));
      const conFile = await Promise.all(attivi.map(async l => {
        try {
          const jf = await api("/api/lavoratori/" + encodeURIComponent(l.id) + "/files");
          return { id: l.id, nome: (l.nome_completo || ((l.nome || "") + " " + (l.cognome || ""))).trim() || l.id, files: jf.files || {} };
        } catch (e) { return { id: l.id, nome: l.nome_completo || l.id, files: {} }; }
      }));
      setLavs(conFile);
    } catch (e) { setErrore(e.message); }
    setCarico(false);
  }

  async function caricaStorico() {
    try { const j = await api("/api/invii"); setStorico(j.invii || []); } catch (e) { setStorico([]); setErrore(e.message); }
  }

  const docAz = [];
  Object.keys(ETI_AZ).forEach(tipo => (az[tipo] || []).forEach(f => docAz.push({ d: { cat: "azienda", tipo, filename: f.filename, scadenza: f.scadenza || "" }, f })));
  const docLav = l => {
    const out = [];
    Object.keys(ETI_LAV).forEach(tipo => ((l.files || {})[tipo] || []).forEach(f => out.push({ d: { cat: "lavoratore", tipo, filename: f.filename, lavId: l.id, lavNome: l.nome, scadenza: f.scadenza || "" }, f })));
    return out;
  };

  const toggle = d => {
    const k = chiave(d);
    setScelti(s => { const n = { ...s }; if (n[k]) delete n[k]; else n[k] = d; return n; });
  };
  const toggleLav = l => {
    const voci = docLav(l).filter(x => !SENSIBILI.includes(x.d.tipo) && x.f.stato !== "scaduto");
    const tutti = voci.length > 0 && voci.every(x => scelti[chiave(x.d)]);
    setScelti(s => {
      const n = { ...s };
      voci.forEach(x => { const k = chiave(x.d); if (tutti) delete n[k]; else n[k] = x.d; });
      return n;
    });
    if (!tutti) setAperti(a => ({ ...a, [l.id]: true }));
  };

  const lista = Object.values(scelti);
  const scaduti = lista.filter(d => {
    const tutti = docAz.concat(...lavs.map(docLav));
    const x = tutti.find(y => chiave(y.d) === chiave(d));
    return x && x.f.stato === "scaduto";
  });

  let ultima = null;
  try { ultima = JSON.parse(localStorage.getItem(CHIAVE_ULTIMA) || "null"); } catch (e) {}
  const usaUltima = () => {
    if (!ultima || !Array.isArray(ultima.docs)) return;
    const esistenti = {};
    docAz.concat(...lavs.map(docLav)).forEach(x => { esistenti[chiave(x.d)] = x.d; });
    const n = {};
    ultima.docs.forEach(d => { const k = chiave(d); if (esistenti[k]) n[k] = esistenti[k]; });
    setScelti(n);
  };

  async function crea() {
    if (!per.trim()) { alert("Scrivi per chi sono i documenti (es. Impresa Rossi – cantiere via Roma)."); return; }
    if (!lista.length) { alert("Spunta almeno un documento."); return; }
    if (scaduti.length && !window.confirm("Attenzione: " + scaduti.length + " documento/i scelto/i è SCADUTO:\n\n" + scaduti.map(d => "• " + nomeFile(d.filename)).join("\n") + "\n\nMandarli lo stesso?")) return;
    setCreando(true);
    try {
      const j = await api("/api/invii", { method: "POST", body: { per: per.trim(), nota: nota.trim(), giorni, docs: lista } });
      setCreato(j);
      try { localStorage.setItem(CHIAVE_ULTIMA, JSON.stringify({ docs: lista })); } catch (e) {}
    } catch (e) { alert("Non riesco a creare il link: " + e.message); }
    setCreando(false);
  }

  const testoMsg = creato ? ("Buongiorno, ecco i documenti di BERTOC PROJECT SRL richiesti" + (per ? " (" + per + ")" : "") + ":\n" + creato.url + "\n\nIl link resta attivo fino al " + dataOra(creato.scade_il) + ".") : "";
  const copia = async () => {
    try { await navigator.clipboard.writeText(creato.url); setCopiato(true); setTimeout(() => setCopiato(false), 2000); }
    catch (e) { window.prompt("Copia il link:", creato.url); }
  };
  const condividi = async () => {
    try { await navigator.share({ title: "Documenti BERTOC PROJECT", text: testoMsg }); } catch (e) {}
  };

  const btn = (attivo) => ({ padding: "9px 14px", borderRadius: 9, border: "1px solid " + (attivo ? C.accent : C.border), background: attivo ? "#f5a62322" : C.surface, color: attivo ? C.accent : C.text, fontSize: 14, fontWeight: 600, cursor: "pointer" });
  const inp = { width: "100%", boxSizing: "border-box", padding: "11px 12px", fontSize: 16, borderRadius: 9, border: "1px solid " + C.border, background: C.surface, color: C.text, outline: "none" };
  const sez = { background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: "12px 14px", marginBottom: 14 };
  const titSez = { fontSize: 12, color: C.muted, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", maxWidth: "100%", height: "100%", zIndex: 9999, background: C.bg, color: C.text, display: "flex", flexDirection: "column", fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ padding: "calc(env(safe-area-inset-top, 0px) + 12px) 14px 12px", borderBottom: "1px solid " + C.border, display: "flex", alignItems: "center", gap: 10 }}>
        <button onClick={onClose} style={{ width: 38, height: 38, borderRadius: 19, border: "none", background: C.surface, color: C.text, fontSize: 17, cursor: "pointer" }} aria-label="Chiudi">✕</button>
        <div style={{ flex: 1, fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 17 }}>📤 Invia documenti</div>
        <button onClick={() => { setTab("nuovo"); }} style={btn(tab === "nuovo")}>Nuovo</button>
        <button onClick={() => { setTab("storico"); caricaStorico(); }} style={btn(tab === "storico")}>Inviati</button>
      </div>

      <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", padding: 14 }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          {errore && <div style={{ ...sez, borderColor: C.err, color: C.err }}>{errore}</div>}

          {tab === "storico" && (
            <div>
              {storico === null && <div style={{ color: C.muted }}>Carico…</div>}
              {storico && storico.length === 0 && <div style={{ color: C.muted }}>Nessun invio ancora.</div>}
              {(storico || []).map(s => (
                <div key={s.token} style={sez}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline" }}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{s.per}</div>
                    <span style={{ fontSize: 12, fontWeight: 700, color: s.stato === "attivo" ? C.ok : C.dim }}>{s.stato === "attivo" ? "ATTIVO" : s.stato === "scaduto" ? "SCADUTO" : "DISATTIVATO"}</span>
                  </div>
                  <div style={{ fontSize: 12, color: C.muted, marginTop: 3 }}>
                    Inviato il {dataOra(s.creato_il)} · {s.n_doc} documenti · scade il {dataOra(s.scade_il)}
                  </div>
                  <div style={{ fontSize: 12, color: s.aperture ? C.ok : C.muted, marginTop: 3 }}>
                    {s.aperture ? ("👁 aperto " + s.aperture + (s.aperture === 1 ? " volta" : " volte") + ", l'ultima il " + dataOra(s.ultima_apertura)) : "non ancora aperto"}
                  </div>
                  <details style={{ marginTop: 6 }}>
                    <summary style={{ fontSize: 12, color: C.muted, cursor: "pointer" }}>Cosa conteneva</summary>
                    <ul style={{ margin: "6px 0 0 18px", padding: 0, fontSize: 13 }}>
                      {(s.docs || []).map((d, i) => <li key={i}>{(d.lavNome ? d.lavNome + " — " : "") + nomeFile(d.filename)}</li>)}
                    </ul>
                  </details>
                  {s.stato === "attivo" && (
                    <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                      <button style={btn(false)} onClick={async () => { try { await navigator.clipboard.writeText(s.url); alert("Link copiato"); } catch (e) { window.prompt("Copia il link:", s.url); } }}>📋 Copia link</button>
                      <button style={{ ...btn(false), color: C.err }} onClick={async () => {
                        if (!window.confirm("Disattivare subito questo link? Chi lo apre non vedrà più i documenti.")) return;
                        try { await api("/api/invii/" + s.token + "/revoca", { method: "POST", body: {} }); caricaStorico(); } catch (e) { alert(e.message); }
                      }}>⛔ Disattiva</button>
                    </div>
                  )}
                  {s.stato !== "attivo" && (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                      <button style={{ ...btn(false), color: C.muted, fontSize: 13, padding: "6px 12px" }} onClick={async () => {
                        if (!window.confirm("Togliere dall'elenco l'invio per «" + s.per + "»?")) return;
                        try { await api("/api/invii/" + s.token, { method: "DELETE" }); caricaStorico(); } catch (e) { alert(e.message); }
                      }}>🗑 Elimina</button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {tab === "nuovo" && creato && (
            <div style={{ ...sez, borderColor: C.ok }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: C.ok, marginBottom: 6 }}>✓ Link pronto</div>
              <div style={{ fontSize: 13, color: C.muted, marginBottom: 10 }}>{lista.length} documenti per «{per}». Attivo fino al {dataOra(creato.scade_il)}.</div>
              <div style={{ fontSize: 13, padding: "10px 12px", background: C.bg, borderRadius: 8, wordBreak: "break-all", marginBottom: 12 }}>{creato.url}</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {typeof navigator !== "undefined" && navigator.share && <button style={btn(true)} onClick={condividi}>📤 Condividi</button>}
                <a style={{ ...btn(false), textDecoration: "none" }} href={"https://wa.me/?text=" + encodeURIComponent(testoMsg)} target="_blank" rel="noopener noreferrer">WhatsApp</a>
                <a style={{ ...btn(false), textDecoration: "none" }} href={"mailto:?subject=" + encodeURIComponent("Documenti BERTOC PROJECT SRL" + (per ? " – " + per : "")) + "&body=" + encodeURIComponent(testoMsg)}>✉️ Email</a>
                <button style={btn(false)} onClick={copia}>{copiato ? "✓ Copiato" : "📋 Copia link"}</button>
              </div>
              <div style={{ marginTop: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
                <a style={{ ...btn(false), textDecoration: "none", fontSize: 13 }} href={creato.url + "?anteprima=1"} target="_blank" rel="noopener noreferrer">👁 Vedi come lo vedono loro</a>
                <button style={{ ...btn(false), fontSize: 13 }} onClick={() => { setCreato(null); setScelti({}); setPer(""); setNota(""); }}>Nuovo invio</button>
              </div>
            </div>
          )}

          {tab === "nuovo" && !creato && (
            <div>
              <div style={sez}>
                <div style={titSez}>Per chi</div>
                <input style={inp} value={per} onChange={e => setPer(e.target.value)} placeholder="Es. Impresa Rossi – cantiere via Roma" />
                <textarea style={{ ...inp, marginTop: 8, minHeight: 60, fontSize: 15, fontFamily: "inherit" }} value={nota} onChange={e => setNota(e.target.value)} placeholder="Messaggio (facoltativo), compare in cima alla pagina" />
                <div style={{ ...titSez, marginTop: 12 }}>Il link resta attivo</div>
                <div style={{ display: "flex", gap: 8 }}>
                  {[1, 3, 7].map(g => <button key={g} style={btn(giorni === g)} onClick={() => setGiorni(g)}>{g === 1 ? "1 giorno" : g + " giorni"}</button>)}
                </div>
              </div>

              {carico && <div style={{ color: C.muted, padding: 10 }}>Carico i documenti…</div>}

              {!carico && ultima && ultima.docs && ultima.docs.length > 0 && lista.length === 0 && (
                <button style={{ ...btn(false), width: "100%", marginBottom: 14 }} onClick={usaUltima}>↺ Stessi documenti dell'ultimo invio ({ultima.docs.length})</button>
              )}

              {!carico && (
                <div style={sez}>
                  <div style={titSez}>🏢 Documenti dell'impresa</div>
                  {Object.keys(ETI_AZ).map(tipo => (az[tipo] || []).length ? (
                    <div key={tipo} style={{ marginTop: 6 }}>
                      <div style={{ fontSize: 12, color: C.accent, margin: "8px 0 2px" }}>{ETI_AZ[tipo]}</div>
                      {(az[tipo] || []).map(f => {
                        const d = { cat: "azienda", tipo, filename: f.filename, scadenza: f.scadenza || "" };
                        return <Riga key={chiave(d)} d={d} f={f} scelto={!!scelti[chiave(d)]} onToggle={toggle} />;
                      })}
                    </div>
                  ) : null)}
                  {docAz.length === 0 && <div style={{ color: C.muted, fontSize: 14 }}>Nessun documento caricato in Sicurezza → Documenti azienda.</div>}
                </div>
              )}

              {!carico && (
                <div style={sez}>
                  <div style={titSez}>👷 Lavoratori</div>
                  {lavs.map(l => {
                    const voci = docLav(l);
                    const nSc = voci.filter(x => scelti[chiave(x.d)]).length;
                    return (
                      <div key={l.id} style={{ borderBottom: "1px solid " + C.border, padding: "8px 0" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <button onClick={() => toggleLav(l)} style={{ ...btn(nSc > 0), padding: "6px 10px", fontSize: 13 }}>{nSc > 0 ? "✓ " + nSc : "+ Tutti"}</button>
                          <div onClick={() => setAperti(a => ({ ...a, [l.id]: !a[l.id] }))} style={{ flex: 1, cursor: "pointer", fontSize: 15, fontWeight: 600 }}>
                            {l.nome} <span style={{ fontSize: 12, color: C.muted, fontWeight: 400 }}>{voci.length} documenti {aperti[l.id] ? "▲" : "▼"}</span>
                          </div>
                        </div>
                        {aperti[l.id] && (
                          <div style={{ marginTop: 4, paddingLeft: 6 }}>
                            {voci.length === 0 && <div style={{ color: C.muted, fontSize: 13, padding: 6 }}>Nessun documento caricato.</div>}
                            {Object.keys(ETI_LAV).map(tipo => {
                              const vt = voci.filter(x => x.d.tipo === tipo);
                              if (!vt.length) return null;
                              return (
                                <div key={tipo}>
                                  <div style={{ fontSize: 12, color: C.accent, margin: "8px 0 2px" }}>{ETI_LAV[tipo]}</div>
                                  {vt.map(x => <Riga key={chiave(x.d)} d={x.d} f={x.f} scelto={!!scelti[chiave(x.d)]} onToggle={toggle} sensibile={SENSIBILI.includes(tipo)} />)}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {lavs.length === 0 && <div style={{ color: C.muted, fontSize: 14 }}>Nessun lavoratore attivo.</div>}
                  <div style={{ fontSize: 12, color: C.dim, marginTop: 8 }}>«+ Tutti» sceglie i documenti validi del lavoratore, esclusi idoneità e documento d'identità (🔒), che vanno spuntati a mano.</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {tab === "nuovo" && !creato && (
        <div style={{ borderTop: "1px solid " + C.border, padding: "12px 14px calc(env(safe-area-inset-bottom, 0px) + 12px)", background: C.bg }}>
          <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ flex: 1, fontSize: 13, color: scaduti.length ? C.err : C.muted }}>
              {lista.length} documenti scelti{scaduti.length ? " · " + scaduti.length + " scaduti" : ""}
            </div>
            <button onClick={crea} disabled={creando} style={{ padding: "13px 20px", borderRadius: 11, border: "none", background: C.accent, color: "#1a1d27", fontSize: 15, fontWeight: 800, cursor: "pointer", opacity: creando ? 0.6 : 1 }}>
              {creando ? "Creo…" : "Crea link"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function InviaDocumentiBtn({ stile }) {
  const [aperta, setAperta] = useState(false);
  return (
    <>
      <button onClick={() => setAperta(true)}
        style={stile || { display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 16px", borderRadius: 10, border: "1px solid " + C.accent, background: "#f5a62322", color: C.accent, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
        📤 Invia documenti
      </button>
      {aperta && <Finestra onClose={() => setAperta(false)} />}
    </>
  );
}
